import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HomeLayout from "../../../../../../components/home_page/HomeLayout";
import NavLayout from "../../../../../../components/NavNameOfComponent/NavLayout";
import Indicator from "../../../../../../components/Indicator/Indicator";
import LedgerVoucherFooter from "../../../../../../components/Footer/LedgerVoucherFooter";
import LedgerMasterDetails from "../../../../../../components/common/LedgerMasterDetails";
import DeletConfirm from "../../../../../../components/Modal/DeletConfirm";
import { useDropdownKeyboardNavigation } from "../../../../../../components/Custom_Hooks/useDropdownKeyboardNavigation";
import { useDropdownScroll } from "../../../../../../components/Custom_Hooks/useDropdownScroll";
import { LINK_PATH } from "../../../../../../constant";
import { useDelet } from "../../../../../../components/Custom_Hooks/useDelete";
import {
  closeModal,
  ledgerPostingList,
  openModal,
  voucherEntryDelete,
} from "../../../../../../redux/actions/action-creator";
import {
  currencyFormate,
  dateFormateSend,
  dateFormateShow,
} from "../../../../../../components/Date_Formate_Utilitiy/Index";

const getMainVoucherId = (item) => {
  if (!item) return "";
  const primaryId = item?.voucher_entries_id;
  if (primaryId && primaryId !== 0 && primaryId !== "0") {
    return primaryId;
  }
  const fallbackId = item?.uid;
  if (fallbackId && fallbackId !== 0 && fallbackId !== "0") {
    return fallbackId;
  }
  return "";
};

const toArray = (value) => {
  if (Array.isArray(value)) return value;
  if (!value) return [];
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }
  return [];
};

const toNumber = (value) => {
  if (value === null || value === undefined) return 0;
  const parsed = Number(String(value).replace(/,/g, "").trim());
  return Number.isFinite(parsed) ? parsed : 0;
};

const toReadableDate = (value) => {
  if (!value) return "";
  try {
    return dateFormateShow(value);
  } catch (error) {
    return String(value);
  }
};

const formatDrCr = (value) => {
  const amount = Math.abs(toNumber(value));
  if (!amount) return "";
  const side = toNumber(value) >= 0 ? "Dr" : "Cr";
  return `${currencyFormate(amount)} ${side}`;
};

const calculateOverdueDays = (dueDateValue, toDateValue) => {
  if (!dueDateValue || !toDateValue) return "";
  const dueDate = new Date(dueDateValue);
  const toDate = new Date(toDateValue);
  if (Number.isNaN(dueDate.getTime()) || Number.isNaN(toDate.getTime()))
    return "";
  const diffMs = toDate.setHours(0, 0, 0, 0) - dueDate.setHours(0, 0, 0, 0);
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return diffDays > 0 ? diffDays : "";
};

const LedgerOutstandingBills = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const { userData } = useSelector((state) => state.auth);
  const { company_session } = useSelector((state) => state.common);
  const modal_state = useSelector((state) => state.common.modal_state);

  const [loading, setLoading] = useState(true);
  const [mainLedgerRecord, setMainLedgerRecord] = useState({});
  const [ledgerName, setLedgerName] = useState(
    location?.state?.ledger_name || "",
  );
  const [rows, setRows] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [removedItems, setRemovedItems] = useState([]);
  const [hiddenRowKeys, setHiddenRowKeys] = useState(new Set());
  const [refreshKey, setRefreshKey] = useState(0);
  const tableBodyRef = useRef(null);

  const fromDateSend =
    location?.state?.send_from_date ||
    dateFormateSend(company_session?.start_financial_year);
  const toDateSend =
    location?.state?.send_to_date ||
    dateFormateSend(company_session?.current_date);

  const fromDateDisplay =
    location?.state?.from_date ||
    dateFormateShow(company_session?.start_financial_year);
  const toDateDisplay =
    location?.state?.to_date || dateFormateShow(company_session?.current_date);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("fromDate", fromDateSend);
        formData.append("toDate", toDateSend);
        formData.append("ledger_id", id);
        formData.append("company_id", userData?.company_id);

        const response = await dispatch(ledgerPostingList(formData));
        if (response?.status) {
          setRows(response?.data?.voucherEntryList || []);
          setMainLedgerRecord(response?.data?.main_ledger_record || {});
          setLedgerName(
            response?.data?.main_ledger_record?.ledger_name ||
              location?.state?.ledger_name ||
              "",
          );
        } else {
          setRows([]);
          setMainLedgerRecord({});
        }
      } catch (error) {
        setRows([]);
        setMainLedgerRecord({});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    dispatch,
    fromDateSend,
    toDateSend,
    id,
    refreshKey,
    userData?.company_id,
    location?.state?.ledger_name,
  ]);

  const groupedRows = useMemo(() => {
    const map = new Map();

    rows.forEach((item) => {
      const billCandidates = [
        ...toArray(item?.bill_wise_details),
        ...toArray(item?.bill_wise_data),
        ...toArray(item?.bill_allocations),
        ...toArray(item?.bill_allocation),
        ...toArray(item?.reference_details),
      ];

      const voucherSignedAmount =
        toNumber(item?.total_debit_amount) -
        toNumber(item?.total_credit_amount);

      const fallbackLine = {
        date: item?.create_date,
        voucherType: item?.voucher_type_name || item?.voucher_type || "",
        voucherNo: item?.voucher_no || item?.serial_no || "",
        amountSigned: voucherSignedAmount,
        referenceNo: item?.voucher_no || item?.serial_no || "Opening",
        dueDate: item?.due_date || item?.bill_due_date || item?.create_date,
        mainVoucherId: getMainVoucherId(item),
      };

      const detailLines =
        billCandidates.length > 0
          ? billCandidates.map((detail) => ({
              date: detail?.create_date || detail?.date || item?.create_date,
              voucherType:
                detail?.voucher_type_name ||
                detail?.voucher_type ||
                item?.voucher_type_name ||
                item?.voucher_type ||
                "",
              voucherNo:
                detail?.voucher_no ||
                detail?.serial_no ||
                item?.voucher_no ||
                item?.serial_no ||
                "",
              amountSigned:
                toNumber(detail?.amount) ||
                toNumber(detail?.pending_amount) ||
                toNumber(detail?.opening_amount) ||
                voucherSignedAmount,
              referenceNo:
                detail?.ref_no ||
                detail?.reference_no ||
                detail?.bill_no ||
                detail?.name ||
                fallbackLine.referenceNo,
              dueDate:
                detail?.due_date ||
                detail?.bill_due_date ||
                item?.due_date ||
                item?.bill_due_date ||
                item?.create_date,
              mainVoucherId: getMainVoucherId(detail) || getMainVoucherId(item),
            }))
          : [fallbackLine];

      detailLines.forEach((line) => {
        const refNo = String(line.referenceNo || "Opening");
        if (!map.has(refNo)) {
          map.set(refNo, {
            referenceNo: refNo,
            openingAmount: 0,
            pendingAmount: 0,
            dueDate: line.dueDate,
            lines: [],
            _lineKeys: new Set(),
          });
        }

        const group = map.get(refNo);
        const lineKey = [
          String(line.mainVoucherId || ""),
          String(line.voucherNo || ""),
          String(line.voucherType || ""),
          String(line.date || ""),
          String(line.dueDate || ""),
          String(toNumber(line.amountSigned)),
        ].join("|");

        if (group._lineKeys.has(lineKey)) {
          return;
        }
        group._lineKeys.add(lineKey);

        const signedAmount = toNumber(line.amountSigned);
        group.pendingAmount += signedAmount;
        if (signedAmount > 0) {
          group.openingAmount += signedAmount;
        }

        if (!group.dueDate && line.dueDate) {
          group.dueDate = line.dueDate;
        }

        group.lines.push(line);
      });
    });

    return [...map.values()].map((group) => ({
      ...group,
      _lineKeys: undefined,
      lines: group.lines.sort(
        (a, b) =>
          new Date(a.date || 0).getTime() - new Date(b.date || 0).getTime(),
      ),
    }));
  }, [rows]);

  const totalOpening = groupedRows.reduce(
    (acc, item) => acc + toNumber(item.openingAmount),
    0,
  );
  const totalPending = groupedRows.reduce(
    (acc, item) => acc + toNumber(item.pendingAmount),
    0,
  );

  const focusableRows = useMemo(() => {
    const list = [];
    groupedRows.forEach((group, groupIndex) => {
      list.push({
        type: "group",
        groupIndex,
        lineIndex: -1,
        key: `${groupIndex}::-1`,
        mainVoucherId: group?.lines?.[0]?.mainVoucherId,
        label:
          `${group.referenceNo || ""} ${toReadableDate(group?.lines?.[0]?.date)}`.trim(),
      });

      group.lines.forEach((line, lineIndex) => {
        list.push({
          type: "line",
          groupIndex,
          lineIndex,
          key: `${groupIndex}::${lineIndex}`,
          mainVoucherId: line?.mainVoucherId,
          label:
            `${line.referenceNo || group.referenceNo || ""} ${line.voucherType || ""} ${line.voucherNo || ""}`.trim(),
        });
      });
    });

    return list;
  }, [groupedRows]);

  const visibleFocusableRows = useMemo(
    () => focusableRows.filter((row) => !hiddenRowKeys.has(row.key)),
    [focusableRows, hiddenRowKeys],
  );

  const rowIndexMap = useMemo(() => {
    const groupMap = new Map();
    const lineMap = new Map();

    visibleFocusableRows.forEach((row, index) => {
      if (row.type === "group") {
        groupMap.set(row.groupIndex, index);
      } else {
        lineMap.set(`${row.groupIndex}::${row.lineIndex}`, index);
      }
    });

    return { groupMap, lineMap };
  }, [visibleFocusableRows]);

  const openVoucherById = (voucherId) => {
    if (!voucherId) return;
    navigate(`../voucher-transaction-view/${voucherId}`);
  };

  const openDuplicateVoucherById = (voucherId) => {
    if (!voucherId) return;
    navigate(`../voucher-transaction/${voucherId}`);
  };

  const openAlterVoucherById = (voucherId) => {
    if (!voucherId) return;
    navigate(`../voucher-transaction-alter/${voucherId}`);
  };

  const openAddVoucher = () => {
    navigate(`../voucherstransaction`);
  };

  const backToLedgerVoucher = () => {
    navigate(`${LINK_PATH}/ledgervoucher/${id}`, { replace: true });
  };

  const getSelectedVoucherIds = () => {
    const idsFromSelection =
      selectedItems.length > 0
        ? selectedItems
            .map((index) => visibleFocusableRows[index]?.mainVoucherId)
            .filter(Boolean)
        : [visibleFocusableRows[selectedItemIndex]?.mainVoucherId].filter(
            Boolean,
          );

    return [...new Set(idsFromSelection.map((idValue) => String(idValue)))];
  };

  const openDeleteModal = () => {
    const ids = getSelectedVoucherIds();
    if (ids.length === 0) return;
    dispatch(openModal("delete"));
  };

  const getRowsToHideByIndex = (index) => {
    const row = visibleFocusableRows[index];
    if (!row) return [];

    if (row.type === "group") {
      const groupLineKeys = focusableRows
        .filter((item) => item.groupIndex === row.groupIndex)
        .map((item) => item.key);
      return groupLineKeys;
    }

    return [row.key];
  };

  const toggleSelection = (index) => {
    const selectedIndex = selectedItems.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedItems, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelected = newSelected.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1),
      );
    }

    setSelectedItems(newSelected);
  };

  const removeSelectedItems = () => {
    if (visibleFocusableRows.length === 0) return;

    const indicesToRemove =
      selectedItems.length > 0 ? [...selectedItems] : [selectedItemIndex];
    const keysToHide = [];

    indicesToRemove.forEach((index) => {
      keysToHide.push(...getRowsToHideByIndex(index));
    });

    const uniqueKeys = [...new Set(keysToHide)].filter(
      (key) => !hiddenRowKeys.has(key),
    );
    if (uniqueKeys.length === 0) return;

    setHiddenRowKeys((prev) => {
      const next = new Set(prev);
      uniqueKeys.forEach((key) => next.add(key));
      return next;
    });
    setRemovedItems((prev) => [...prev, uniqueKeys]);
    setSelectedItems([]);
  };

  const restoreSelectedItems = () => {
    if (removedItems.length === 0) return;
    const lastRemoved = removedItems[removedItems.length - 1];

    setHiddenRowKeys((prev) => {
      const next = new Set(prev);
      lastRemoved.forEach((key) => next.delete(key));
      return next;
    });
    setRemovedItems((prev) => prev.slice(0, -1));
  };

  const getSelectedRow = () => visibleFocusableRows[selectedItemIndex];

  const { delteItem, loadingDelete } = useDelet({
    prepareFormData: () => {
      const formData = new FormData();
      const ids = getSelectedVoucherIds();
      const idsString = ids.join(",");

      formData.append("uid", idsString);
      formData.append("id", idsString);
      formData.append("company_id", userData?.company_id);
      return formData;
    },
    submitForm: async (formData) => {
      const response = await dispatch(voucherEntryDelete(formData));
      if (response?.status) {
        setSelectedItems([]);
        setRemovedItems([]);
        setHiddenRowKeys(new Set());
        setRefreshKey((prev) => prev + 1);
      }
      return response;
    },
    shortcuts: [
      {
        key: "a",
        ctrlKey: true,
        action: () => delteItem(new Event("submit")),
      },
    ],
    closeModal: () => dispatch(closeModal("delete")),
    state: modal_state?.delete,
  });

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }
        backToLedgerVoucher();
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [backToLedgerVoucher]);

  const { selectedItemIndex, setSelectedItemIndex } =
    useDropdownKeyboardNavigation({
      items: visibleFocusableRows,
      state:
        !loading && visibleFocusableRows.length > 0 && !modal_state?.delete,
      onItemSelect: (item) => {
        openVoucherById(item?.mainVoucherId);
      },
      onItemControlEnterSelect: (item) => {
        openAlterVoucherById(item?.mainVoucherId);
      },
      onItemSpaceSelect: () => {
        toggleSelection(selectedItemIndex);
      },
      onItemAlt2Select: (item) => {
        openDuplicateVoucherById(item?.mainVoucherId);
      },
      onItemAltISelect: (item) => {
        openDuplicateVoucherById(item?.mainVoucherId);
      },
      onItemAltRSelect: () => {
        removeSelectedItems();
      },
      onItemAltUSelect: () => {
        restoreSelectedItems();
      },
      onItemAltDSelect: () => {
        openDeleteModal();
      },
      onItemAltASelect: () => {
        openAddVoucher();
      },
      enableAlphaJump: true,
      getLabel: (item) => item?.label || "",
      containerRef: tableBodyRef,
      initialIndex: 0,
    });

  useEffect(() => {
    const handleFooterShortcuts = (e) => {
      if (loading || visibleFocusableRows.length === 0) return;
      if (modal_state?.delete) return;
      if (
        document.querySelector(".modal_link") ||
        document.querySelector(".modal_message")
      ) {
        return;
      }

      const activeElement = document.activeElement;
      const tagName = activeElement?.tagName?.toLowerCase();
      const isTypingContext =
        tagName === "input" ||
        tagName === "textarea" ||
        tagName === "select" ||
        activeElement?.isContentEditable;
      if (isTypingContext) return;

      if (e.metaKey) return;

      if (e.altKey && !e.ctrlKey) {
        const altKey = e.key;
        if (altKey === "a" || altKey === "A") {
          e.preventDefault();
          e.stopPropagation();
          openAddVoucher();
        } else if (altKey === "2") {
          e.preventDefault();
          e.stopPropagation();
          openDuplicateVoucherById(getSelectedRow()?.mainVoucherId);
        } else if (altKey === "i" || altKey === "I") {
          e.preventDefault();
          e.stopPropagation();
          openDuplicateVoucherById(getSelectedRow()?.mainVoucherId);
        } else if (altKey === "d" || altKey === "D") {
          e.preventDefault();
          e.stopPropagation();
          openDeleteModal();
        } else if (altKey === "r" || altKey === "R") {
          e.preventDefault();
          e.stopPropagation();
          removeSelectedItems();
        } else if (altKey === "u" || altKey === "U") {
          e.preventDefault();
          e.stopPropagation();
          restoreSelectedItems();
        }
        return;
      }

      if (e.ctrlKey) return;

      const key = e.key;
      if (key === "a" || key === "A") {
        e.preventDefault();
        e.stopPropagation();
        openAddVoucher();
      } else if (key === "2") {
        e.preventDefault();
        e.stopPropagation();
        openDuplicateVoucherById(getSelectedRow()?.mainVoucherId);
      } else if (key === "i" || key === "I") {
        e.preventDefault();
        e.stopPropagation();
        openDuplicateVoucherById(getSelectedRow()?.mainVoucherId);
      } else if (key === "d" || key === "D") {
        e.preventDefault();
        e.stopPropagation();
        openDeleteModal();
      } else if (key === "r" || key === "R") {
        e.preventDefault();
        e.stopPropagation();
        removeSelectedItems();
      } else if (key === "u" || key === "U") {
        e.preventDefault();
        e.stopPropagation();
        restoreSelectedItems();
      } else if (key === "x" || key === "X") {
        e.preventDefault();
        e.stopPropagation();
        backToLedgerVoucher();
      }
    };

    document.addEventListener("keydown", handleFooterShortcuts, true);
    return () => {
      document.removeEventListener("keydown", handleFooterShortcuts, true);
    };
  }, [
    loading,
    modal_state?.delete,
    visibleFocusableRows.length,
    getSelectedRow,
    backToLedgerVoucher,
    openDeleteModal,
    removeSelectedItems,
    restoreSelectedItems,
  ]);

  useEffect(() => {
    setSelectedItems((prev) =>
      prev.filter((index) => index >= 0 && index < visibleFocusableRows.length),
    );

    if (visibleFocusableRows.length === 0) {
      setSelectedItemIndex(0);
      return;
    }

    if (selectedItemIndex >= visibleFocusableRows.length) {
      setSelectedItemIndex(visibleFocusableRows.length - 1);
    }
  }, [
    visibleFocusableRows.length,
    selectedItemIndex,
    setSelectedItemIndex,
    setSelectedItems,
  ]);

  useDropdownScroll({
    dropdownRef: tableBodyRef,
    selectedItemIndex,
  });

  return (
    <HomeLayout
      data={{
        state_configure: { formate_of_report: "Detailed" },
      }}
    >
      <div
        className="container-fluid px-0"
        style={{ overflowX: "hidden", paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="px-1">
          <NavLayout>
            <b>Ledger Outstandings</b>
            <span>{`${fromDateDisplay} To ${toDateDisplay}`}</span>
          </NavLayout>

          <LedgerMasterDetails
            ledger={{
              ...mainLedgerRecord,
              ledger_name: mainLedgerRecord?.ledger_name || ledgerName,
            }}
          />
        </div>

        <div className="row">
          <div className="col-12 p-0 m-0">
            <div className="row mx-0 px-1 mt-0 border_2_2px_top border_2_1px_bottom heading_dyn_creation_data">
              <div className="col-1 font_size" style={{ width: "9%" }}>
                Date
              </div>
              <div className="col-1 font_size" style={{ width: "10%" }}>
                Ref. No.
              </div>
              <div className="col-3 font_size" style={{ width: "26%" }}>
                Particulars
              </div>
              <div
                className="col-2 text-end font_size"
                style={{ width: "15%" }}
              >
                Opening Amount
              </div>
              <div
                className="col-2 text-end font_size"
                style={{ width: "15%" }}
              >
                Pending Amount
              </div>
              <div
                className="col-1 text-end font_size"
                style={{ width: "12%" }}
              >
                Due On
              </div>
              <div
                className="col-1 text-end font_size"
                style={{ width: "13%" }}
              >
                Overdue by days
              </div>
            </div>
          </div>
        </div>

        {modal_state?.delete ? (
          <DeletConfirm
            handleSubmit={delteItem}
            loading={loadingDelete}
            closeModal={() => dispatch(closeModal("delete"))}
          />
        ) : null}

        <div
          ref={tableBodyRef}
          style={{ height: "70vh", overflowY: "auto", overflowX: "hidden" }}
        >
          {loading ? (
            <Indicator />
          ) : groupedRows.length === 0 ? (
            <p className="text-center mt-4">
              No bill-wise data found for this ledger.
            </p>
          ) : (
            groupedRows.map((group, groupIndex) => {
              if (hiddenRowKeys.has(`${groupIndex}::-1`)) {
                return null;
              }

              return (
                <div key={`${group.referenceNo}-${groupIndex}`}>
                  <div
                    className={`row mx-0 px-0 mt-0 ${selectedItems.includes(rowIndexMap.groupMap.get(groupIndex)) ? "selected_multi" : ""}`}
                    style={{
                      background:
                        selectedItemIndex ===
                        rowIndexMap.groupMap.get(groupIndex)
                          ? selectedItems.includes(
                              rowIndexMap.groupMap.get(groupIndex),
                            )
                            ? "#2b63c5"
                            : "#f0c13b"
                          : "#f5e3a1",
                      borderBottom: "1px solid #ddd",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setSelectedItemIndex(
                        rowIndexMap.groupMap.get(groupIndex) || 0,
                      )
                    }
                  >
                    <div className="col-1 font_size" style={{ width: "9%" }}>
                      {toReadableDate(group?.lines?.[0]?.date)}
                    </div>
                    <div className="col-1 font_size" style={{ width: "10%" }}>
                      {group.referenceNo}
                    </div>
                    <div
                      className="col-3 font_size"
                      style={{ width: "26%" }}
                    ></div>
                    <div
                      className="col-2 text-end font_size"
                      style={{ width: "15%" }}
                    >
                      {formatDrCr(group.openingAmount)}
                    </div>
                    <div
                      className="col-2 text-end font_size"
                      style={{ width: "15%" }}
                    >
                      {formatDrCr(group.pendingAmount)}
                    </div>
                    <div
                      className="col-1 text-end font_size"
                      style={{ width: "12%" }}
                    >
                      {toReadableDate(group.dueDate)}
                    </div>
                    <div
                      className="col-1 text-end font_size"
                      style={{ width: "13%" }}
                    >
                      {calculateOverdueDays(group.dueDate, toDateSend)}
                    </div>
                  </div>

                  {group.lines.map((line, lineIndex) => {
                    if (hiddenRowKeys.has(`${groupIndex}::${lineIndex}`)) {
                      return null;
                    }

                    return (
                      <div
                        key={`${group.referenceNo}-${lineIndex}`}
                        className={`row mx-0 px-0 mt-0 ${selectedItems.includes(rowIndexMap.lineMap.get(`${groupIndex}::${lineIndex}`)) ? "selected_multi" : ""}`}
                        style={{
                          borderBottom: "1px solid #f0f0f0",
                          cursor: "pointer",
                          backgroundColor:
                            selectedItemIndex ===
                            rowIndexMap.lineMap.get(
                              `${groupIndex}::${lineIndex}`,
                            )
                              ? selectedItems.includes(
                                  rowIndexMap.lineMap.get(
                                    `${groupIndex}::${lineIndex}`,
                                  ),
                                )
                                ? "#2b63c5"
                                : "#f0c13b"
                              : "transparent",
                        }}
                        onClick={() =>
                          setSelectedItemIndex(
                            rowIndexMap.lineMap.get(
                              `${groupIndex}::${lineIndex}`,
                            ) || 0,
                          )
                        }
                      >
                        <div
                          className="col-1 font_size"
                          style={{ width: "9%" }}
                        >
                          {toReadableDate(line.date)}
                        </div>
                        <div
                          className="col-1 font_size"
                          style={{ width: "10%" }}
                        >
                          {line.referenceNo || group.referenceNo}
                        </div>
                        <div
                          className="col-3 font_size"
                          style={{ width: "26%" }}
                        >
                          {`${line.voucherType || ""} ${line.voucherNo || ""}`.trim()}
                        </div>
                        <div
                          className="col-2 text-end font_size"
                          style={{ width: "15%" }}
                        ></div>
                        <div
                          className="col-2 text-end font_size"
                          style={{ width: "15%" }}
                        >
                          {formatDrCr(line.amountSigned)}
                        </div>
                        <div
                          className="col-1 text-end font_size"
                          style={{ width: "12%" }}
                        >
                          {toReadableDate(line.dueDate)}
                        </div>
                        <div
                          className="col-1 text-end font_size"
                          style={{ width: "13%" }}
                        >
                          {calculateOverdueDays(line.dueDate, toDateSend)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })
          )}
        </div>

        <LedgerVoucherFooter
          isDisable={removedItems.length === 0}
          isSelectionEmpty={visibleFocusableRows.length === 0}
          backFunction={backToLedgerVoucher}
          viewFunction={() => openVoucherById(getSelectedRow()?.mainVoucherId)}
          alterFunction={() =>
            openAlterVoucherById(getSelectedRow()?.mainVoucherId)
          }
          AddVchFunction={openAddVoucher}
          spaceFunction={() => toggleSelection(selectedItemIndex)}
          duplicateFunction={() =>
            openDuplicateVoucherById(getSelectedRow()?.mainVoucherId)
          }
          insertFunction={() =>
            openDuplicateVoucherById(getSelectedRow()?.mainVoucherId)
          }
          deleteFunction={openDeleteModal}
          cancelFunction={backToLedgerVoucher}
          removeLineFunction={() => removeSelectedItems()}
          restoreLineFunction={() => restoreSelectedItems()}
          isDeleteDisabled={visibleFocusableRows.length === 0}
        >
          <div className="row px-1 mt-0 border_2_2px_top table_footer_font">
            <div className="col-7 text-end fw-bold">Total</div>
            <div className="col-2 text-end fw-bold">
              {formatDrCr(totalOpening)}
            </div>
            <div className="col-2 text-end fw-bold">
              {formatDrCr(totalPending)}
            </div>
            <div className="col-1"></div>
          </div>
        </LedgerVoucherFooter>
      </div>
    </HomeLayout>
  );
};

export default LedgerOutstandingBills;
